import React from 'react';
import { BodyText } from '@keen.io/typography';
import { Container } from './Label.styles';

var Label = function Label(_ref) {
  var children = _ref.children;
  return React.createElement(Container, null, React.createElement(BodyText, {
    variant: "body2",
    fontWeight: "bold"
  }, children));
};

export default Label;